import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m13.855 2.804 1.444 1.082 1.812.272.023.004c1.351.246 2.574 1.259 2.713 2.766l.176 1.76 1.141 1.318.002.002c.958 1.096.923 2.694.03 3.847l-1.082 1.444-.272 1.812-.004.023c-.245 1.345-1.249 2.561-2.744 2.71l-1.693.268-1.43 1.072c-1.096.94-2.68.9-3.826.012l-1.444-1.082-1.812-.272-.023-.004c-1.352-.246-2.574-1.259-2.713-2.767l-.177-1.776-1.068-1.335c-.891-1.145-.933-2.734.008-3.83L3.986 8.7l.27-1.792c.142-1.457 1.22-2.494 2.61-2.747l.06-.008 1.763-.177 1.319-1.143c1.096-.958 2.694-.923 3.847-.03M5.3 9.45l-1.2 1.6-.036.044c-.438.5-.475 1.296.025 1.942l1.197 1.495a.75.75 0 0 1 .16.394l.201 2.007c.062.688.635 1.271 1.477 1.428l1.987.298a.75.75 0 0 1 .339.142l1.61 1.208c.647.503 1.444.467 1.946.028L13.05 20l1.6-1.2a.75.75 0 0 1 .333-.14l1.9-.3.05-.007c.687-.062 1.27-.635 1.427-1.477l.298-1.987a.75.75 0 0 1 .142-.339l1.208-1.61c.503-.647.467-1.444.028-1.946l-.003-.003-1.3-1.5a.75.75 0 0 1-.18-.416l-.2-2.007c-.062-.688-.635-1.271-1.477-1.428l-1.987-.298a.75.75 0 0 1-.339-.142l-1.61-1.208c-.647-.503-1.444-.467-1.946-.028l-.003.003-1.5 1.3a.75.75 0 0 1-.416.18l-1.968.196c-.787.153-1.294.702-1.36 1.425l-.005.043-.3 2a.75.75 0 0 1-.142.339",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15.154 10.247a.5.5 0 0 1 0 .707l-3.5 3.5a.5.5 0 0 1-.707 0l-2.1-2.1a.5.5 0 1 1 .707-.707l1.746 1.746 3.146-3.147a.5.5 0 0 1 .708 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }